import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/snapshot.module.css";

const ListingDetails = (props) => {
    const { listing, width } = props;
    const { participant } = listing;

    const mls = participant ? participant.mls : null;
    const agent = participant ? participant.agent : null;
    const broker = participant ? participant.broker : null;
    const office = participant ? participant.office : null;

    // -----------------------------------------
    // SOURCE & PROVIDER
    // -----------------------------------------
    const source = (
        <div className={css.column}>
            <div className={css.label}>Source</div>
            <div className={css.valueUppercase}>{listing.source}</div>
        </div>
    );

    const providerName = (
        <div className={css.column}>
            <div className={css.label}>Provider</div>
            <div className={css.value}>
                {listing.provider_url && (
                    <a
                        href={listing.provider_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.link}
                    >
                        {listing.provider_name}
                    </a>
                )}
                {!listing.provider_url && listing.provider_name}
            </div>
        </div>
    );

    const listingOriginalUrl = (
        <div className={css.column}>
            <div className={css.label}>URL</div>
            <div className={css.value}>
                {listing.original_url && (
                    <a
                        href={listing.original_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.link}
                    >
                        Listing page
                    </a>
                )}
            </div>
        </div>
    );

    // -----------------------------------------
    // MLS
    // -----------------------------------------
    const mlsId = (
        <div className={css.column}>
            <div className={css.label}>MLS ID</div>
            <div className={css.value}>{mls && mls.short_name}</div>
        </div>
    );

    const mlsName = (
        <div className={css.column}>
            <div className={css.label}>MLS Name</div>
            <div className={css.value}>{mls && mls.long_name}</div>
        </div>
    );

    const mlsNumber = (
        <div className={css.column}>
            <div className={css.label}>MLS Number</div>
            <div className={css.value}>{mls && mls.number}</div>
        </div>
    );

    const mlsDisclaimer = (
        <div>
            <div className={css.disclaimer}>{mls && mls.disclaimer}</div>
        </div>
    );

    // -----------------------------------------
    // PARTICIPANT
    // -----------------------------------------
    const participantName = (
        <div className={css.column}>
            <div className={css.label}>Name</div>
            <div className={css.value}>
                {agent && (
                    <>
                        {agent.first_name} {agent.middle_name} {agent.last_name}
                    </>
                )}
            </div>
        </div>
    );

    const participantEmail = (
        <div className={css.column}>
            <div className={css.label}>Email</div>
            <div className={css.value}>{agent && agent.email}</div>
        </div>
    );

    const participantPrimaryPhone = (
        <div className={css.column}>
            <div className={css.label}>Primary Phone</div>
            <div className={css.value}>{agent && agent.phone}</div>
        </div>
    );

    const participantFax =
        agent && agent.fax ? (
            <div className={css.column}>
                <div className={css.label}>Fax</div>
                <div className={css.value}>{agent.fax}</div>
            </div>
        ) : (
            ""
        );

    const participantKey = (
        <div className={css.column}>
            <div className={css.label}>Key</div>
            <div className={css.value}>{agent && agent.source_key}</div>
        </div>
    );

    // -----------------------------------------
    // BROKER
    // -----------------------------------------
    const brokerName = (
        <div className={css.column}>
            <div className={css.label}>Name</div>
            <div className={css.value}>{broker && broker.name}</div>
        </div>
    );

    const brokerPhone = (
        <div className={css.column}>
            <div className={css.label}>Phone</div>
            <div className={css.value}>{broker && broker.phone}</div>
        </div>
    );

    const brokerFax =
        broker && broker.fax ? (
            <div className={css.column}>
                <div className={css.label}>Fax</div>
                <div className={css.value}>{broker.fax}</div>
            </div>
        ) : (
            ""
        );

    // -----------------------------------------
    // OFFICE
    // -----------------------------------------
    const officeName = (
        <div className={css.column}>
            <div className={css.label}>Name</div>
            <div className={css.value}>{office && office.name}</div>
        </div>
    );

    const officePhone = (
        <div className={css.column}>
            <div className={css.label}>Phone</div>
            <div className={css.value}>{office && office.phone}</div>
        </div>
    );

    let details;

    if (width && width < 1100) {
        details = (
            <div className={css.snapshot}>
                <div className={css.row}>
                    {providerName}
                    {mlsId}
                    {mlsName}
                    {mlsNumber}
                    {listingOriginalUrl}
                    {source}

                    <div className={css.title}>PARTICIPANT</div>
                    {participantName}
                    {participantEmail}
                    {participantPrimaryPhone}
                    {participantFax}
                    {participantKey}

                    <div className={css.title}>BROKER</div>
                    {brokerName}
                    {brokerPhone}
                    {brokerFax}

                    <div className={css.title}>OFFICE</div>
                    {officeName}
                    {officePhone}

                    {mlsDisclaimer}
                </div>
            </div>
        );
    } else {
        details = (
            <div className={css.snapshot}>
                <div className={css.row}>
                    {providerName}
                    {mlsId}
                </div>
                <div className={css.row}>
                    {mlsName}
                    {mlsNumber}
                </div>
                <div className={css.row}>
                    {listingOriginalUrl}
                    {source}
                </div>

                <div className={css.title}>PARTICIPANT</div>

                <div className={css.row}>
                    {participantName}
                    {participantPrimaryPhone}
                </div>
                <div className={css.row}>
                    {participantKey}
                    {participantEmail}
                </div>
                {participantFax && (
                    <div className={css.row}>{participantFax}</div>
                )}

                <div className={css.title}>BROKER</div>

                <div className={css.row}>
                    {brokerName}
                    {brokerPhone}
                </div>
                {brokerFax && <div className={css.row}>{brokerFax}</div>}

                <div className={css.title}>OFFICE</div>

                <div className={css.row}>
                    {officeName}
                    {officePhone}
                </div>

                <div className={css.row}>{mlsDisclaimer}</div>
            </div>
        );
    }

    return details;
};

ListingDetails.propTypes = {
    listing: PropTypes.object.isRequired,
    width: PropTypes.number,
};

export default ListingDetails;
